// Page-view pixel — fires on every route change.
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PageViewTracker() {
  const location = useLocation();
  const lastPath = useRef("");

  useEffect(() => {
    const path = location.pathname + (location.search || "");
    if (path === lastPath.current) return;
    lastPath.current = path;
    if (path.startsWith("/admin") || path.startsWith("/login")) return; // skip admin pages
    axios
      .post(
        `${API}/analytics/pageview`,
        { path, referrer: document.referrer || "" },
        { withCredentials: false },
      )
      .catch(() => {});
  }, [location]);

  return null;
}
